import * as angular from "angular";
import { Constants as constants } from "@constants/shared";
import { CommsRepo as fileRepo } from "@services/communications.repo";
import { commList } from "@app/communications/communicationList";
import { newComm } from "@app/communications/newComm/newComm";

export const communicationModule = "communications";

angular
  .module(communicationModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService",
  ])
  .constant("config", constants.Default)
  .service("fileRepo", fileRepo)
  .component("commList", commList)
  .component("newComm", newComm);



// WEBPACK FOOTER //
// ./src/app/communications/communication.index.ts